import { Fragment } from 'react'
import ProductsTitle from './ProductsTitle'
import ProductsList from './ProductsList'

const Products = () => {
	return (
		<Fragment>
			<ProductsTitle />
			<ProductsList />
		</Fragment>
	)
}

export default Products
